// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"254":"2deb315b6202f616","376":"50c756a74ca94a75","390":"b4b1f9958d17dced","689":"1be3b91e9084dd8d","783":"07fc2c0b3d50cf18","873":"2547d88ad80ba65c","975":"d8823b3f752112e7"}[chunkId] + ".js";
};